import styled from "@emotion/styled";

export const Root = styled.div({
    display: "flex",
    flexDirection: "column",
    height: "100%",
});

export const UnitList = styled.nav({
    display: "flex",
    justifyContent: "stretch",
    flexDirection: "column",
    flexBasis: "100%",

    flexGrow: 1,
    flexShrink: 1,
    overflow: "hidden",
    position: "relative",
});

export const AtBottom = styled.div({
    flexGrow: 0,
    flexShrink: 0,
});
